module.exports = __webpack_public_path__ + "photo-7.656803fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/images/building/full/photo-7.jpg
// module id = 629
// module chunks = 0